import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i258159602__a" }, [
        _createElementVNode("rect", {
          width: "28",
          height: "28",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i258159602__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M11.37 26.24Q.468 23.654 5.14 12.03c.542.498.87 1.367 1.124 1.873.588-6.095 5.157-6.688 4.501-12.154 1.767.629 7.337 2.483 8.203 9.305C19.8 9.5 21.08 8.671 22.05 8.507c-.243 1.225.153 3.336 1.039 5.496 1.367 3.344 1.455 10-5.436 11.725 1.04-2.42 1.455-6.344-3.738-9.669-.919 4.206-5.556 5.324-2.545 10.18Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "hot"}) } }